import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Page } from "../../Page";
import styles from './EventTaskWizard.module.css'
import { useEffect } from "react";
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setPromptOkCancelOnBack, setPromptOkCancelOnHome } from "../menu/menuSlice";
import { selectCurrentEventTaskType, setEventTitle } from "../currentEventTask/currentEventTaskSlice";
import { AdditionalFoodEventTaskInfo } from "../currentEventTask/AdditionalFoodEventTaskInfo";
import { AdditionalSendMoneyTaskInfo } from "../currentEventTask/AdditionalSendMoneyTaskInfo";
import { setMessage } from "../messageBoxes/messageBoxSlice";
import { BackButton } from "../menu/BackButton";

export function ChooseEventTask() {
    const currentEventTaskType = useAppSelector(selectCurrentEventTaskType)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setPromptOkCancelOnHome(true))
        dispatch(setMessage('Cancel saving this task and return to the home page?'))
      }, [dispatch]);
    return (
        <Page> 
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
            <h1>PartyPlanner</h1>
            <br></br>
            <h2>Choose your task type!</h2>
            <br></br>
            <p>This is where you can create tasks for people coming to your event. There are three options available which are 'Pay money Task', 'Bring Food Task' and 'Other task', which is customisable to your liking, for you to create.</p>
            </div>
            <br></br>
            <label className={styles.label} htmlFor='selectTaskType'>Task type:</label>
            <select
                id='selectTaskType'
                className={styles.textbox}
                aria-label="Select Task Type"
                onChange={(e) => dispatch(setEventTitle(e.target.value))}
            >
                <option value={0}>Other Task</option>
                <option value={1}>Bring food task</option>
                <option value={2}>Pay money task</option>
            </select>
            { currentEventTaskType === 1 ? <AdditionalFoodEventTaskInfo/> : null }
            { currentEventTaskType === 2 ? <AdditionalSendMoneyTaskInfo/> : null}
            <br></br>
            <button className={styles.nextButton} onClick={() => {
                navigate('/Email')
            }}>Next</button>
        </Page>
    )
}